import cx from 'classnames';
import React from 'react';

import { generateColor } from '@/utils/styles';

import styles from './Avatar.module.scss';
import { IAvatarProps, EAvatarSize } from './Avatar.types';

export const Avatar: React.FC<IAvatarProps> = ({
  userName,
  size = EAvatarSize.MEDIUM,
  className = '',
  url,
}) => {
  const avatarChar = userName ? userName.charAt(0).toUpperCase() : '';

  return (
    <div
      className={cx(styles.avatar, [styles[size]], className, {
        [styles.image]: Boolean(url),
      })}
      style={{
        backgroundColor: generateColor(avatarChar),
        ...(url ? { backgroundImage: `url(${url})` } : {}),
      }}
    >
      <span translate="no">{avatarChar}</span>
    </div>
  );
};
